import { Info } from '@mui/icons-material';
import { ClickAwayListener, IconButton, Tooltip, useMediaQuery } from '@mui/material';
import { useState } from 'react';

/**
 * Info icon whose tooltip opens on hover with a mouse and on tap with a finger.
 *
 * MUI's Tooltip is hover-driven, and on touch only reacts to a long-press on a focusable
 * child — a bare SVG is neither, so on a phone it never opens. The button gives it a tap
 * target and `open` is driven here instead. The hover handlers are bound only for real
 * pointers: a touch browser fires `mouseenter` just before `click`, so binding them there
 * would open the tooltip and let the click immediately toggle it shut again.
 */
function InfoTooltip({ title }: { title: string }) {
    const [open, setOpen] = useState(false);
    const canHover = useMediaQuery('(hover: hover)');

    return (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Tooltip
                title={title}
                open={open}
                onClose={() => setOpen(false)}
                disableFocusListener
                disableHoverListener
                disableTouchListener
            >
                <IconButton
                    aria-label={title}
                    size='small'
                    sx={{
                        p: 0,
                        '& .MuiSvgIcon-root': {
                            width: '16px !important',
                            height: '16px !important',
                        },
                    }}
                    onClick={() => setOpen((isOpen) => !isOpen)}
                    {...(canHover ? { onMouseEnter: () => setOpen(true), onMouseLeave: () => setOpen(false) } : {})}
                >
                    <Info sx={{ color: (theme) => theme.palette.primary.onSurface }} />
                </IconButton>
            </Tooltip>
        </ClickAwayListener>
    );
}

export default InfoTooltip;
